import type { RootState } from '@/store/root-reducer';

const selectCompaniesState = (state: RootState) => state.companies;

export const selectRows = (state: RootState) => selectCompaniesState(state).rows;
export const selectTotal = (state: RootState) => selectCompaniesState(state).total;
export const selectLoading = (state: RootState) => selectCompaniesState(state).loading;
export const selectError = (state: RootState) => selectCompaniesState(state).error;
export const selectPage = (state: RootState) => selectCompaniesState(state).page;
export const selectPageSize = (state: RootState) => selectCompaniesState(state).pageSize;
